export default "__VITE_ASSET__B2mcBT21__"